import { render } from "./OrderShippings.vue?vue&type=template&id=1bfb8fd9"
import script from "./OrderShippings.vue?vue&type=script&lang=js"
export * from "./OrderShippings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__